/* eslint-disable valid-jsdoc */
/**
 * Search component
 */
class SearchBox {
    state = {
        content: "",
        typing: false,
        typingTimeout: 0,
    };
    options = {};
    #TIMEOUT = 1000; // milisconds
    $el = $();
    $ul = $();
    #search_data = [];
    #selected_key = "";

    callback = () => {};

    /**
     *
     * @param {string} element_id
     * @param {function} search_callback
     * @param {Object} options
     * @param {function} [options.searching]
     * @param {function} [options.done]
     * @param {function} [options.on_search_fail]
     * @param {function} [options.onSelect]
     * @param {Object} [options.select] - If wants to show data in a select box
     * @param {boolean} options.select.enable - If wants to show data in a select box
     * @param {string | (data)=>string} options.select.title - key of search data to show as selected text
     * @param {string |  (data)=>string} [options.select.key] - key of search data to save as value
     */
    constructor(element_id, search_callback, options) {
        this.$el = $("#" + element_id);
        this.callback = search_callback;
        this.options = options;

        if ("select" in options) {
            if ("enable" in options.select && options.select.enable) {
                const list = `<ul class="search_list is_hidden" data-for="${element_id}"></ul>`;
                this.$el.after(list);
                const $ul = this.$el.next("ul.search_list");
                this.$ul = $ul;
            }
        } else {
            this.options.select = { enable: false };
        }
    }

    /**
     * Add required events to search element
     */
    render() {
        this.$el
            .on("input change", this.#onSearch)
            .on("focus", () => {
                if (this.#search_data.length > 0) {
                    this.$ul.removeClass("is_hidden");
                }
            })
            .on("focusout", () => {
                const title = this.$el.data("title");
                if (title) this.$el.val(title);
            });

        if (this.$ul.length > 0) {
            $(document).on("click", (event) => {
                const $target = $(event.target);
                if (
                    !$target.is(this.$ul) &&
                    !$target.parent().is(this.$ul) &&
                    !$target.is(this.$el)
                ) {
                    this.$ul.addClass("is_hidden");
                }
            });

            this.$ul.on("click", "li.search_list_item", (event) => {
                event.preventDefault();
                event.stopPropagation();
                const $this = $(event.target).is("li.search_list_item")
                    ? $(event.target)
                    : $(event.target).parents("li.search_list_item");
                const title = $this.text();
                const key = $this.data("key");

                this.$el
                    .val(title)
                    .attr("value", title)
                    .data("key", key)
                    .data("title", title);
                this.#selected_key = key;
                this.$ul.addClass("is_hidden");

                if ("onSelect" in this.options) {
                    this.options.onSelect(key, $this.get(0), this);
                }
            });
        }

        return this;
    }

    /**
     * Resets the search box
     */
    reset() {
        this.#setState({
            content: "",
            typing: false,
            typingTimeout: 0,
        });
        this.#search_data = [];
        this.#selected_key = "";
        this.$ul.addClass("is_hidden").empty();
        this.$el.val("");
    }

    /**
     * @return {string}
     */
    getValue() {
        return this.#selected_key;
    }

    /**
     *
     * @param {string} title
     * @param {string} key
     */
    setValue(title, key) {
        this.$el
            .val(title)
            .attr("value", title)
            .data("key", key)
            .data("title", title);
        this.#selected_key = key;
        this.$ul.addClass("is_hidden");
        this.state = {
            content: title,
            typing: false,
            typingTimeout: 0,
        };
        if ("onSelect" in this.options) {
            this.options.onSelect(key);
        }
    }

    #setState = (state) => {
        this.state = state;
    };

    #onSearch = (event) => {
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        if (event.target.value.length > 2 || event.target.value.length === 0) {
            if (this.state.content !== event.target.value) {
                if ("searching" in this.options) this.options.searching();
                this.#setState({
                    content: event.target.value,
                    typing: false,
                    typingTimeout: setTimeout(() => {
                        this.#doSearch().then(() => {
                            if ("done" in this.options) this.options.done();
                            if (this.options.select.enable) {
                                this.#showSelect();
                            }
                        });
                    }, this.#TIMEOUT),
                });
            }
        } else {
            this.#setState({
                content: "",
                typing: false,
                typingTimeout: null,
            });

            if (this.$ul.length > 0) {
                this.$ul.empty().addClass("is_hidden");
            }
        }
    };

    /**
     * private method to show select
     * @returns {Promise}
     */
    #showSelect() {
        const li_list =
            this.#search_data.length > 0
                ? this.#search_data
                      .map((data) => {
                          const okey = this.options.select.key;
                          const otitle = this.options.select.title;

                          const key =
                              typeof okey === "function"
                                  ? okey(data)
                                  : data[okey];
                          const title =
                              typeof otitle === "function"
                                  ? otitle(data)
                                  : data[otitle];
                          return `<li class="search_list_item" data-key="${key}">${title}</li>`;
                      })
                      .join("")
                : "<p>موردی پیدا نشد</p>";
        this.$ul.empty().append(li_list).removeClass("is_hidden");
    }

    /**
     * private method to do search
     * @returns {Promise}
     */
    #doSearch() {
        return new Promise((resolve, reject) => {
            try {
                if (this.options.select.enable) {
                    Promise.resolve(this.callback()).then((data) => {
                        this.#search_data = data;
                        resolve();
                    });
                } else {
                    this.callback();
                    resolve();
                }
            } catch (error) {
                if ("on_search_fail" in this.options) {
                    this.options.on_search_fail();
                } else {
                    reject();
                }
            }
        });
    }
}

export { SearchBox };
